import { Button } from "@portal/BaseComponents/Button/AntButton";
import { Dropdown } from "@portal/BaseComponents/Dropdown/AntDropdown";
import { DropdownOriginNode } from "@portal/BaseComponents/Dropdown/type";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import {
  MenuClick,
  MenuGroup,
  MenuProps,
} from "@portal/BaseComponents/Menu/type";
import { Icon } from "@portal/lib/icons/icons";
import { popUpContainerPredicate } from "@portal/util/predicates";
import { filter } from "lodash";
import { useMemo, useState } from "react";
import { FilterDropdownWrapper } from "./style";

const PlusIcon = <Icon icon={["far", "plus"]} color="var(--primary-7)" />;

const t = {
  title: "Filters",
};

interface FilterDropDownButtonProps {
  items: MenuGroup[];
  handleClick: (info: MenuClick["0"]) => void;
  selectedValues: string[];
}

const filterEmptyChildrenPredicate = (item: MenuGroup) => item.children?.length;
const filterChildrenPredicate = (item: MenuGroup) => item.children;
function FilterDropDownButton(props: FilterDropDownButtonProps) {
  const { items, handleClick, selectedValues } = props;
  const [selectedKeys, setSelectedKeys] = useState(selectedValues);

  function handleClickCallBack(info: MenuClick["0"]) {
    handleClick?.(info);

    setSelectedKeys((previousKeys) => {
      return [...(previousKeys ?? []), info.key];
    });
  }

  function handleItems() {
    return items.filter(filterEmptyChildrenPredicate).map((item) => {
      return {
        ...item,
        children: filter(item.children, (value) => {
          return !selectedKeys?.includes(String(value?.key));
        }),
      };
    });
  }

  const modifiedItems = useMemo(handleItems, [items, selectedKeys]);

  const isHide = modifiedItems.flatMap(filterChildrenPredicate).length;

  function customDropdownRenderer(menu: DropdownOriginNode) {
    return <FilterDropdownWrapper>{menu}</FilterDropdownWrapper>;
  }

  const menu: MenuProps = {
    items: modifiedItems ?? [],
    onClick: handleClickCallBack,
  };

  return (
    <HideWrapper hide={!isHide}>
      <Dropdown
        menu={menu}
        trigger={["click"]}
        autoAdjustOverflow
        getPopupContainer={popUpContainerPredicate}
        dropdownRender={customDropdownRenderer}
      >
        <Button icon={PlusIcon} actionButton>
          {t.title}
        </Button>
      </Dropdown>
    </HideWrapper>
  );
}

export { FilterDropDownButton };
